// L'ORA DEL SERVER, VISTA DAL CLIENT
//
// Le scadenze dei power-up arrivano dal server come istanti assoluti:
// `visionEndTime = Date.now() + 8000`, calcolato con l'orologio del SERVER.
// Il client le confrontava con il proprio `Date.now()`, e i due orologi non
// sono la stessa cosa.
//
// Il difetto che ne usciva e' quello segnalato dai tester: «a volte il VISION
// dura tre secondi». Non "a volte" — sempre, ma solo per chi ha l'orologio
// avanti. Con cinque secondi di anticipo un effetto da otto ne dura tre, uno
// da cinque (SPEED) non parte proprio, uno da dodici (RADAR) ne dura sette.
// Sono pochissimi utenti perche' sono pochissimi quelli con l'ora sbagliata, e
// quando succede sbagliano TUTTI gli effetti nella stessa misura — che e'
// anche il modo per riconoscere il caso.
//
// La cura e' non usare mai due orologi diversi per la stessa domanda: il server
// manda la propria ora in `init_game`, qui si calcola lo scarto una volta, e da
// li' in poi ogni confronto avviene nell'ora del server.
//
// Cosa questo NON corregge, ed e' bene saperlo: lo scarto include il viaggio di
// andata del pacchetto, quindi e' preciso a meno di qualche decina di
// millisecondi. Contro effetti che durano secondi non e' un errore che si veda,
// e non vale la pena di un giro di ping per limarlo.

// Di quanto l'orologio del server e' avanti rispetto a questo.
export function scartoOrologio(oraServer, oraLocale = Date.now()) {
  if (!Number.isFinite(oraServer)) return 0;   // server vecchio: si resta com'e'
  return oraServer - oraLocale;
}

// Quanti millisecondi mancano a una scadenza del server. Mai negativo.
export function tempoRestante(scadenza, scarto = 0, oraLocale = Date.now()) {
  if (!scadenza) return 0;
  return Math.max(0, scadenza - (oraLocale + scarto));
}

// L'effetto e' ancora attivo?
export function ancoraAttivo(scadenza, scarto = 0, oraLocale = Date.now()) {
  return tempoRestante(scadenza, scarto, oraLocale) > 0;
}
